// Dấu hiệu "bảng còn cột bên phải" (02/10/2026). Ở màn hẹp (390 px) mọi bảng .tbl rộng hơn khung chỉ cuộn ngang mà không có dấu hiệu gì —
// người dùng không biết nút thao tác (Tài khoản), cột Lý do (Lịch sử), cột Lịch (Gói seeding)… nằm ngoài màn.
// Một bộ theo dõi CHUNG cho mọi trang (không sửa từng trang):
//  · dòng chữ "↔ Kéo ngang để xem thêm" ngay TRÊN bảng — chỉ hiện khi bảng tràn;
//  · mép phải bảng mờ dần (lớp .con-phai) khi còn cột bên phải chưa thấy — kéo tới cuối thì hết mờ.
// Bảng thêm/bớt dòng, đổi cỡ màn → ResizeObserver; bảng mới vẽ (đổi trang, vẽ lại) → MutationObserver.
const GOI_Y = "tbl-goi-y";

const daTheoDoi = new WeakSet<HTMLElement>();
let ro: ResizeObserver | null = null;

function capNhat(tbl: HTMLElement): void {
  const tran = tbl.scrollWidth > tbl.clientWidth + 1;
  const conPhai = tran && tbl.scrollLeft + tbl.clientWidth < tbl.scrollWidth - 1;
  tbl.classList.toggle("tran-ngang", tran);
  tbl.classList.toggle("con-phai", conPhai);
  let gy = tbl.previousElementSibling as HTMLElement | null;
  if (!gy || !gy.classList.contains(GOI_Y)) {
    if (!tran) return; // không tràn thì không cần chèn gì
    gy = document.createElement("p");
    gy.className = `${GOI_Y} small muted`;
    gy.dataset.testid = GOI_Y;
    gy.setAttribute("aria-hidden", "true"); // trình đọc màn hình đọc bảng theo hàng/cột, không cần câu hướng dẫn kéo
    gy.textContent = "↔ Kéo ngang để xem thêm";
    tbl.before(gy);
  }
  gy.hidden = !tran;
}

function theoDoi(tbl: HTMLElement): void {
  if (!daTheoDoi.has(tbl)) {
    daTheoDoi.add(tbl);
    tbl.addEventListener("scroll", () => capNhat(tbl), { passive: true });
    ro?.observe(tbl);
  }
  // Bảng bên trong đổi rộng (thêm dòng có chữ dài) mà khung không đổi → theo dõi cả bảng con.
  const t = tbl.firstElementChild as HTMLElement | null;
  if (t && !daTheoDoi.has(t)) { daTheoDoi.add(t); ro?.observe(t); }
  capNhat(tbl);
}

function quet(goc: ParentNode): void {
  // Gợi ý mồ côi (bảng của nó đã bị thay/xoá) → bỏ.
  goc.querySelectorAll<HTMLElement>(`.${GOI_Y}`).forEach((g) => { if (!g.nextElementSibling?.classList.contains("tbl")) g.remove(); });
  goc.querySelectorAll<HTMLElement>(".tbl").forEach(theoDoi);
}

/** Bật một lần lúc khởi động trang. */
export function batGoiYCuonBang(): void {
  if (ro || typeof ResizeObserver === "undefined") return;
  // Đổi DOM ngay trong lượt báo của ResizeObserver dễ gây "ResizeObserver loop…" (lỗi console) → gom lại, làm ở khung hình kế.
  const cho = new Set<HTMLElement>();
  let henRo = 0;
  ro = new ResizeObserver((ds) => {
    for (const d of ds) {
      const el = d.target as HTMLElement;
      const tbl = el.classList.contains("tbl") ? el : el.parentElement?.classList.contains("tbl") ? el.parentElement : null;
      if (tbl) cho.add(tbl);
    }
    if (!henRo && cho.size) henRo = requestAnimationFrame(() => { henRo = 0; const ds2 = [...cho]; cho.clear(); for (const t of ds2) if (t.isConnected) capNhat(t); });
  });
  let hen = 0;
  new MutationObserver(() => {
    if (hen) return;
    hen = requestAnimationFrame(() => { hen = 0; quet(document.body); });
  }).observe(document.body, { childList: true, subtree: true });
  quet(document.body);
}
